import { ChevronLeft, ChevronRight } from "lucide-react";
import { MyButton } from "./MyButton";
import { cn } from "../../utils/utils";

export const MyPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  className,
}) => {
  return (
    <div className={cn("flex items-center justify-end my-2", className)}>
      {/* <span className="text-sm text-muted-foreground"> */}
      {/*   Page {currentPage} of {totalPages} */}
      {/* </span> */}
      {totalPages > 1 && (
        <div className="flex items-center space-x-1">
          {currentPage !== 1 && (
            <MyButton
              variant="outline"
              size="icon"
              className="!min-h-8 !min-w-8 !p-0"
              onClick={() => onPageChange(currentPage - 1)}
            >
              <ChevronLeft className="h-5 w-5" />
            </MyButton>
          )}

          {Array.from({ length: totalPages }).map((_, index) => (
            <MyButton
              key={index}
              variant={currentPage === index + 1 ? "default" : "outline"}
              className="!min-h-8 !min-w-8 !p-0"
              onClick={() => onPageChange(index + 1)}
            >
              <span className="text-sm">{index + 1}</span>
            </MyButton>
          ))}
          {currentPage !== totalPages && (
            <MyButton
              variant="outline"
              className="!min-h-8 !min-w-8 !p-0"
              onClick={() => onPageChange(currentPage + 1)}
            >
              <ChevronRight className="h-5 w-5" />
            </MyButton>
          )}
        </div>
      )}
    </div>
  );
};
